var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDocumentsIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    x: 0,
    y: 0,
    viewBox: "0 0 24 24",
    fillRule: "evenodd",
    className: "",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M20.75 20c0 .729-.29 1.429-.805 1.945A2.755 2.755 0 0 1 18 22.75H6c-.729 0-1.429-.29-1.945-.805A2.755 2.755 0 0 1 3.25 20V4c0-.729.29-1.429.805-1.945A2.755 2.755 0 0 1 6 1.25h8.586c.464 0 .909.184 1.237.513l4.414 4.414c.329.328.513.773.513 1.237zM8 18.75h4.5a.75.75 0 0 0 0-1.5H8a.75.75 0 0 0 0 1.5zm0-3.5h8a.75.75 0 0 0 0-1.5H8a.75.75 0 0 0 0 1.5zM14.5 3v3.5a1 1 0 0 0 1 1H19zM8 11.75h8a.75.75 0 0 0 0-1.5H8a.75.75 0 0 0 0 1.5z",
    fill: "#5555FF",
    opacity: 1,
    "data-original": "#000000",
    className: ""
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocumentsIcon);
export default __webpack_public_path__ + "static/media/DocumentsIcon.bddf943f9e6dca65aec2722e3057d48f.svg";
export { ForwardRef as ReactComponent };